import Flags from "./flags";

export const sendFromCountries = [
  { name: "United Kingdom", flag: Flags.UkFlag, currency: ["GBP"] },
];
export const sendToCountries = [
  {
    name: "Somalia",
    flag: Flags.SomFlag,
    services: ["Pickup", "Bank Deposit", "Mobile Wallet"],
    currency: ["GBP", "USD"],
    defaultCurrency: ["USD"],
  },
  {
    name: "Kenya",
    flag: Flags.KeFlag,
    services: ["Pickup", "MPESA"],
    currency: ["GBP", "KES"],
    defaultCurrency: ["KES"],
  },
  {
    name: "Djibouti",
    flag: Flags.DjFlag,
    services: ["Pickup"],
    currency: ["GBP", "USD"],
    defaultCurrency: ["USD"],
  },
  {
    name: "Ethiopia",
    flag: Flags.EtFlag,
    services: ["Pickup", "Bank Deposit"],
    currency: ["GBP", "ETB"],
    defaultCurrency: ["ETB"],
  },
  {
    name: "Uganda",
    flag: Flags.UgFlag,
    services: ["Pickup"],
    currency: ["GBP", "UGX"],
    defaultCurrency: ["UGX"],
  },
  {
    name: "Tanzania",
    flag: Flags.TzFlag,
    services: ["Mobile Africa"],
    currency: ["GBP", "TZS"],
    defaultCurrency: ["TZS"],
  },
  {
    name: "United Arab Emirates",
    flag: Flags.UaeFlag,
    services: ["Pickup"],
    currency: ["GBP", "AED"],
    defaultCurrency: ["AED"],
  },
  {
    name: "Rwanda",
    flag: Flags.Rwanda,
    services: ["Pickup"],
    currency: ["GBP", "RWF"],
    defaultCurrency: ["RWF"],
  },
  {
    name: "Ghana",
    flag: Flags.Ghana,
    services: ["Pickup"],
    currency: ["GBP", "GHS"],
    defaultCurrency: ["GHS"],
  },
  {
    name: "Nigeria",
    flag: Flags.Nigeria,
    services: ["Pickup"],
    currency: ["GBP", "NGN"],
    defaultCurrency: ["NGN"],
  },
  {
    name: "South Africa",
    flag: Flags.SouthAfrica,
    services: ["Pickup"],
    currency: ["GBP", "ZAR"],
    defaultCurrency: ["ZAR"],
  },
  {
    name: "Egypt",
    flag: Flags.Egypt,
    services: ["Pickup"],
    currency: ["GBP", "EGP"],
    defaultCurrency: ["EGP"],
  },
];
